import { Component, Input } from "@angular/core";
import { TableHelperService } from "../../../../services/table-helper.service";

@Component({
	selector: "app-table-column-filter",
	templateUrl: "./TableColumnFilter.component.html",
})
export class TableColumnFilterComponent {
	@Input() column: any;
	@Input() table: any;

	constructor(public tableHelperService: TableHelperService) {}
}
